'use client';

import {FC} from 'react';
import {Link, Typography} from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';

type LongTextProps = {
  text: string;
};

/**
 * Renders a Contentful "Long text" plain field as Markdown, preserving
 * single-line breaks and converting legacy "• " bullet lines into list items.
 */
export const LongText: FC<LongTextProps> = ({text}) => {
  // legacy "• " bullets become real Markdown lists
  const normalized = text.replace(/^• /gm, '- ');

  return (
    <ReactMarkdown
      remarkPlugins={[remarkBreaks]}
      components={{
        p: ({children}) => <Typography sx={{marginBottom: 1}}>{children}</Typography>,
        a: ({href, children}) => (
          <Link href={href ?? '#'} color='text.link' underline='hover'>
            {children}
          </Link>
        ),
        ul: ({children}) => <ul style={{paddingLeft: 20, margin: '8px 0'}}>{children}</ul>,
        li: ({children}) => (
          <li style={{marginBottom: 4}}>
            <Typography component='span'>{children}</Typography>
          </li>
        ),
      }}
    >
      {normalized}
    </ReactMarkdown>
  );
};